import type * as React from "react";

type Props = {
	/** Desktop sticky top bar. */
	topBar?: React.ReactNode;
	/** Mobile fixed bottom tab bar. */
	tabBar?: React.ReactNode;
	/** Slim footer, rendered at the end of the flow (optional). */
	footer?: React.ReactNode;
	children: React.ReactNode;
	/**
	 * Pin the layout to the viewport height and let the main region manage its
	 * own scrolling (map page). Without it the page scrolls normally.
	 */
	fullBleed?: boolean;
};

export function AppShell({
	topBar,
	tabBar,
	footer,
	children,
	fullBleed = false,
}: Props) {
	return (
		<div
			className={`flex flex-col bg-[var(--surface-muted)] text-[var(--content-primary)] ${
				fullBleed ? "h-screen overflow-hidden" : "min-h-screen"
			}`}
		>
			{topBar}
			<main
				className={
					fullBleed
						? "min-h-0 flex-1 overflow-hidden"
						: "flex-1 pb-[calc(84px+env(safe-area-inset-bottom))] md:pb-0"
				}
			>
				{children}
			</main>
			{footer}
			{tabBar && (
				<div className="fixed inset-x-0 bottom-0 z-[900] md:hidden">
					{tabBar}
				</div>
			)}
		</div>
	);
}
